import {BaseAttribute} from "@/pages/AppPages/Events/attribute";

export class VaccinationEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams)
        this.vaccineName = null;
        this.vaccineSeries = null;
        this.vaccineNumber = null;
        this.vaccineAgainst = null;
        this.vetSpecialist = null;
        this.conclusion = null;
    }

    static get modelName() {
        return 'ClinicalEvent'
    }

    static get validations() {
        return {
            vaccineName: {},
            vaccineSeries: {},
            vaccineNumber: {},
            vaccineAgainst: {},
            vetSpecialist: {},
            conclusion: {}
        }
    }

    static get validationFieldLabels() {
        return {
            vetSpecialist: 'Ветеринар',
            vaccineName: 'Вакцина',
            vaccineSeries: 'Серия',
            vaccineNumber: 'Номер',
            vaccineAgainst: 'Вакцина против',
            conclusion: 'Заключение'
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    applyData(data) {
        this.vetSpecialist = data['vetSpecialist'];
        this.vaccineName = data['vaccineName'];
        this.vaccineSeries = data['vaccineSeries'];
        this.vaccineNumber = data['vaccineNumber'];
        this.vaccineAgainst = data['vaccineAgainst'];
        this.conclusion = data['conclusion'];
    }

}